import i18n from "i18n";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { Collections } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
const INITIAL_DATA = {
  pagination: { total: 0 },
  list: [],
  attributes: []
};
export const COLLECTIONS_QUERY_KEY = "collections";
export const keyFn = (searchParams) => [COLLECTIONS_QUERY_KEY, searchParams];
export const fetchPaginatedCollections = async (searchParams, editable = false) => Collections.getPage(
  searchParams.sort.attributeId,
  searchParams.page,
  searchParams.pageSize,
  searchParams.query,
  searchParams.sort.direction,
  editable
).then(({ elements, query, attributes, pagination: { count, total, page, per_page: perPage } }) => ({
  list: elements,
  attributes,
  pagination: {
    count,
    total,
    page,
    perPage,
    query
  }
}));
const useCollections = (searchParams, { enabled } = { enabled: true }) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: keyFn(searchParams),
    queryFn: () => defaultOnError(
      fetchPaginatedCollections(searchParams),
      i18n.t("notifications.fetch_collections_failed", { ns: "enterprise_collections" }),
      i18n.t("notifications.fetch_collections_failed_title", { ns: "enterprise_collections" })
    ),
    placeholderData: keepPreviousData,
    enabled
  });
  return {
    data: data != null ? data : INITIAL_DATA,
    isLoading,
    refetch
  };
};
export default useCollections;
